import { render, staticRenderFns } from "./header-top.vue?vue&type=template&id=52312516&scoped=true"
import script from "./header-top.vue?vue&type=script&lang=js"
export * from "./header-top.vue?vue&type=script&lang=js"
import style0 from "./header-top.vue?vue&type=style&index=0&id=52312516&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52312516",
  null
  
)

export default component.exports